import React, { useState } from 'react';
import { useIntl } from "react-intl";

const Feedback = ({ onSubjectChange, onFeedbackChange, subject, desc, submitFeedback, isFeedbackInvalid, isSubjectInvalid ,isDisabled}) => {
    const intl = useIntl();
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const handleSubmit = async () => {
        const response = await submitFeedback();

        if (response && response.error) {
            setMessage(response.data.response[0].message);
            setMessageType('error');
        } else if (response && response.data) {
            setMessage(response.data.response[0].message);
            setMessageType(response.data.code==0 ? 'success' : 'error');
        }

        setTimeout(() => {
            setMessage('');
            setMessageType('');
        }, 4000);
    };

    return (
        <div className="feedback-container">
            <p>{intl.formatMessage({ id: "CHAT.AddFeedback" })}</p>
            <label className="feedback-label">
                <input
                    type="text"
                    value={subject}
                    onChange={onSubjectChange}
                    className={`mobile-input ${isSubjectInvalid ? 'invalid-input' : ''}`}
                    placeholder={intl.formatMessage({ id: "CHAT.TELLUS" })}
                />
            </label>
            <textarea
                className={`feedback-textarea ${isFeedbackInvalid ? 'invalid-input' : ''}`}
                placeholder={intl.formatMessage({ id: "CHAT.ENTERFEED" })}
                onChange={onFeedbackChange}
                value={desc}
            ></textarea>
            <button className="feedback-button" onClick={handleSubmit} disabled={isDisabled} >
                {intl.formatMessage({ id: "CHAT.SEND" })}
            </button>
            {message && (
                <div className={`response-message ${messageType}`}>
                    {message}
                </div>
            )}

        </div>
    );
};

export default Feedback;